module.exports = __webpack_public_path__ + "img/case-banner__bg2.png?c89b44ffa3a06c5f1d3e2922d03022e9";